import type { FC, PropsWithChildren } from "react";
import React, { useMemo } from "react";

import cn from "classnames";

import { getChildrenRecord } from "../../../../../utils/react";
import { AVATARSVIEW_DISPLAY_NAME } from "../../AvatarsView";

import type { OmitOfUnion } from "../../../../../types/react";
import type { AvatarsViewSize } from "../../types";

import classes from "../../AvatarsView.styl";

const AVATARS_VIEW_ITEMS_TEST_ID = "avatars-view-items-test-id";

type ContentAvatarsViewItemsProps = PropsWithChildren<{
    size: AvatarsViewSize;
}>;

type ConstantAvatarsViewItemsProps = "size";
type AvatarsViewItemsProps = OmitOfUnion<
    ContentAvatarsViewItemsProps,
    ConstantAvatarsViewItemsProps
>;
const AvatarsViewItems: FC<AvatarsViewItemsProps> = (props) => {
    const { size, children } = props as ContentAvatarsViewItemsProps;

    const avatarsArray = useMemo(() => {
        return getChildrenRecord(
            children,
            AVATARSVIEW_DISPLAY_NAME,
            {
                Avatar: {
                    props: { size },
                    required: true,
                },
                Unknown: {
                    skipElement: true,
                },
            },
            { isArrayResult: true },
        );
    }, [children, size]);

    return (
        <div
            className={classes["avatars-container"]}
            data-tsid={AVATARS_VIEW_ITEMS_TEST_ID}
        >
            {avatarsArray.map((child, index) => (
                <div
                    key={index}
                    className={cn(
                        classes["avatar-wrapper"],
                        classes[`__size-${size}`],
                    )}
                >
                    {child}
                </div>
            ))}
        </div>
    );
};

AvatarsViewItems.displayName = "AvatarsView.Items";

export default AvatarsViewItems;
